var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoice Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 44H2.12125C1.57045 44 1.12334 43.5546 1.12126 43.0038L1.01141 14.0114C1.00512 12.3501 2.35009 11 4.01139 11H5.99999H22.625H41C39.345 11 38.0051 12.345 38.0114 14L38.1212 42.9962C38.1233 43.55 37.675 44 37.1212 44H22.625H11.625Z",
    fill: "#C7CCCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 11V11C39.345 11 38.0051 12.345 38.0114 14L38.1212 42.9962C38.1233 43.55 37.675 44 37.1212 44H22.625H11.625H2.12125C1.57045 44 1.12334 43.5546 1.12126 43.0038L1.01141 14.0114C1.00512 12.3501 2.35009 11 4.01139 11H5.99999H22.625H41ZM41 11H42C43.1045 11 44 10.1046 44 9V2.18605L44 2.00003C44 1.44773 43.5523 1 43 1H22.5H6.99999C6.44771 1 5.99999 1.44771 5.99999 2L5.99996 10",
    stroke: "#C7CCCA",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoice);
export default __webpack_public_path__ + "static/media/icon_invoice.3fb1f57b9df5c94c6220956b8b6604df.svg";
export { ForwardRef as ReactComponent };